import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import ThankYou from "./pages/ThankYou";
import Replay from "./pages/Replay";
import { PrivacyPolicy, TermsConditions } from "./pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/replay" element={<Replay />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0e1526",
            border: "1px solid #22304e",
            color: "#dfe6f2",
          },
        }}
      />
    </div>
  );
}

export default App;
